// Senders — read-only catalog of every sender_identity. We deliberately don't
// expose an "add new" form yet — adding a new from-address is a domain-trust
// decision that should go through admin + DKIM check, not a click in the UI.

import { useSenderIdentities } from '../lib/queries';

export function Senders() {
  const q = useSenderIdentities();
  const rows = q.data ?? [];

  return (
    <div className="page">
      <header className="page__head">
        <div className="page__rule">
          <span>Section 03</span>
          <span>Senders</span>
          <span>{rows.length} identities</span>
        </div>
        <h1 className="page__title">Senders</h1>
        <p className="page__deck">
          Every from-address we use, with its provider and whether it’s the default
          for cold sends, replies, or both.
        </p>
      </header>

      {q.isLoading && <p><em>Loading senders…</em></p>}
      {q.error && (
        <p className="page__deck page__deck--error">
          Couldn’t load senders: <code>{q.error.message}</code>
        </p>
      )}

      <div className="sender-grid">
        {rows.map((s) => (
          <article key={s.id} className="sender-card">
            <header className="sender-card__head">
              <h3 className="sender-card__name">
                {s.display_name}
                {s.is_default && (
                  <span className="sender-card__default-star" aria-label="default">★</span>
                )}
              </h3>
              <div className="sender-card__rule">
                <span className="sender-card__provider">{s.provider}</span>
                <span className="sender-card__use-for">use · {s.use_for}</span>
                {!s.active && (
                  <span className="sender-card__inactive">inactive</span>
                )}
              </div>
            </header>
            <dl className="sender-card__meta">
              <dt>From</dt>
              <dd><code>{s.from_email}</code></dd>
              {s.reply_to && (
                <>
                  <dt>Reply-To</dt>
                  <dd><code>{s.reply_to}</code></dd>
                </>
              )}
            </dl>
            {s.signature_html && (
              <div className="sender-card__signature">
                <span className="sender-card__label">Signature</span>
                <div
                  className="sender-card__signature-preview"
                  dangerouslySetInnerHTML={{ __html: s.signature_html }}
                />
              </div>
            )}
            {s.notes && <p className="sender-card__notes"><em>{s.notes}</em></p>}
          </article>
        ))}
      </div>

      <footer className="sender-grid__foot">
        <span>
          To add a new sender, contact admin — no UI for adding new email
          addresses (guardrail against unauthorized from-domains).
        </span>
      </footer>
    </div>
  );
}
